import React from 'react';
import { Box } from '@tapresearch/ui/components';
import { Virtuoso } from 'react-virtuoso';

export const FreeTextAnswersList = ({
  answers = [],
}: {
  answers: string[];
}) => {
  return (
    <Box w="full" my={6}>
      <Virtuoso
        style={{ height: '400px' }}
        totalCount={answers.length}
        itemContent={(index) => (
          <Box borderBottom="1px solid" borderColor="gray.200" py={5} px={2}>
            {answers[index]}
          </Box>
        )}
      />
    </Box>
  );
};
